import { FirebaseAuthentication } from '@capacitor-firebase/authentication';

import type { OAuthProvider, User } from 'firebase/auth';

export async function getNativeUser(): Promise<User | null> {
  const nativeUser = await FirebaseAuthentication.getCurrentUser();
  return nativeUser?.user ? (nativeUser.user as unknown as User) : null;
}

export async function requireUser(getUser: () => Promise<User | null>, action: string): Promise<User> {
  const user = await getUser();
  if (!user) {
    throw new Error(`No firebase user available when trying to ${action}`);
  }
  return user;
}

export function requireProvider(provider: OAuthProvider | null, providerName: string): OAuthProvider {
  if (!provider) {
    throw new Error(`${providerName} provider is not initialized`);
  }
  return provider;
}

export function serializeNativeError(error: unknown): Record<string, unknown> {
  if (error && typeof error === 'object') {
    const err = error as Record<string, unknown>;
    const ownProps = Object.getOwnPropertyNames(err).reduce<Record<string, unknown>>((acc, key) => {
      acc[key] = err[key];
      return acc;
    }, {});
    return {
      name: err.name,
      code: err.code,
      message: err.message,
      ...ownProps
    };
  }
  return { message: String(error) };
}
